import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { workflowKeys } from './workflowKeys';

export function useRestoreWorkflow() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: (workflowId: string) =>
      apiClient.post(`api/v1/t/${tenantId}/workflows/${workflowId}/restore`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: workflowKeys.lists() });
    },
  });
}
